module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "acknowledgments"
    }
  }), _vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("M")]), _vm._v("y daughter for her patience and constant love (Helena), my agent (Manie) and my editor (Monique), guys, you are “the dream team.” "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f00ix-01.jpg"
    }
  }), _vm._v(" Then what would the VHL be without The Street Team? (Holla!) Plus we have the entire St. Martin’s team, from fabulous cover art (Michael) to sales (Gina, you go, girl—smile!), support staff (Miss Kia), publicity (Colleen), events coordination (the inimitable Harriet), and every person who functions behind the scenes to make this happen. (Matthew: big hug for allowing us to go this far, man!) Then let’s not forget the Yahoo! Groups, the forum, and MySpace moderators, along with the new fan club president: Alicia, Gudrun, Chantay, and LaShonda, respectively. They keep the info flowing and the buzz buzzing each and every day. Whew, bless you! Plus, we’ve got folks kicking up dust like awesome Webmaster Walt Stone, "), _c('em', [_vm._v("hot")]), _vm._v(" publicist Iola Harper, plus Sheila Clover on new vids, and Sherine and Monique working behind the scenes. There’s a whole hidden team that people don’t see—much like the Guardians, but they are handlin’ their bizness and making it look like it’s easy when it’s not. You "), _c('em', [_vm._v("all")]), _vm._v(" are deeply appreciated—much love!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c150588c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 75
// module chunks = 0